import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { DueCollection } from '@/lib/types';

export async function listDueCollections(
    shopId: number | string
): Promise<DueCollection[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.dueCollections.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}
